import { render, staticRenderFns } from "./BookingTransitions.vue?vue&type=template&id=6f342ef3&scoped=true&"
import script from "./BookingTransitions.vue?vue&type=script&lang=js&"
export * from "./BookingTransitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f342ef3",
  null
  
)

export default component.exports